import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const ReportSunsetExportRequest = (values, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RanReportKpis/GenerateAcceptanceSunsetReport`,
	data: { values, userId }
});
